var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundingNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.25H11.6962L16.9462 6H14V4.5H19.5V10H18V7.05375L12.3037 12.75L4.5 12.75V11.25ZM13.4193 14.5038L14.5038 13.4193L18 16.9462V14H19.5V19.5H14V18H16.9462L13.4193 14.5038Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingNavigator);
export default __webpack_public_path__ + "static/media/fundingNavigator.03b3fc62f4ca16282f61387560c09c05.svg";
export { ForwardRef as ReactComponent };